export function FooterSection() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span>
          Trickyleaf S.r.l. · Viale delle Legioni Romane 43, 20147 Milan · P.IVA / C.F. 12830250960
        </span>
        <span>
          PEC <a href="mailto:trickyleaf@pec.it">trickyleaf@pec.it</a> · © {new Date().getFullYear()} All
          rights reserved
        </span>
      </div>
    </footer>
  );
}
